import { render, staticRenderFns } from "./DefaultWorkflow.vue?vue&type=template&id=6ab13b81&scoped=true&"
import script from "./DefaultWorkflow.vue?vue&type=script&lang=js&"
export * from "./DefaultWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./DefaultWorkflow.vue?vue&type=style&index=0&id=6ab13b81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab13b81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepper,VStepperContent,VStepperItems})
